
import { HttpModelConverter } from '../../../../../../core/converter/httpModel.converter';
import { Injectable } from '@angular/core';
import { TreatmentFeedbackSummaryModel } from '../treatment-feedback.summary.model';
import {LovValueSummaryConverter} from '../../../../../../common/lov/lov-value/api/converter/LovValueSummary.converter';
import {UserSummaryConverter} from '../../../../../../account/modules/user/api/converter/userSummary.converter';

@Injectable()
export class TreatmentFeedbackSummaryConverter extends HttpModelConverter<TreatmentFeedbackSummaryModel> {

    constructor(private lovValueSummaryConverter: LovValueSummaryConverter) {
        super();
    }

    protected createInstance(): TreatmentFeedbackSummaryModel {
        return new TreatmentFeedbackSummaryModel();
    }

    protected enrichObject(result: TreatmentFeedbackSummaryModel, src: TreatmentFeedbackSummaryModel) {
        result.patientFeedback = this.lovValueSummaryConverter.convert(src.patientFeedback);
        result.userFeedback = this.lovValueSummaryConverter.convert(src.userFeedback);
        result.responsible = new UserSummaryConverter().convert(src.responsible);
    }

}
